import styled from 'styled-components';

import { Button } from '@nhl/nhl-breakaway-ui';

export const IconButton = styled(Button)`
    padding: 0;
    height: 44px;
    min-width: 36px;
    max-width: 44px;
    width: 100%;

    svg {
        height: 24px;
        width: 24px;
    }
`;
